module.exports = __webpack_public_path__ + "static/media/logo.001bec57.png";